import React from 'react';
import { X } from 'lucide-react';

interface PrivacyPolicyModalProps {
  onClose: () => void;
}

export default function PrivacyPolicyModal({ onClose }: PrivacyPolicyModalProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white p-4 border-b border-gray-200 flex justify-between items-center">
          <h2 className="text-xl font-semibold text-gray-900">Política de Privacidade</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        <div className="p-6 space-y-6">
          <section>
            <p className="text-gray-600 mb-4">
              Na Kontty, valorizamos a sua privacidade e temos o compromisso de proteger as suas informações pessoais. 
              Esta Política de Privacidade descreve como coletamos, usamos e protegemos suas informações quando você usa nossos serviços.
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-3">1. Informações que coletamos</h3>
            <p className="text-gray-600 mb-2">
              Podemos coletar os seguintes tipos de informações:
            </p>
            <ul className="list-disc ml-6 space-y-2 text-gray-600">
              <li>
                <strong>Informações pessoais:</strong> incluem seu nome, endereço de e-mail, número de telefone e qualquer outra informação que você fornecer ao criar uma conta ou entrar em contato conosco.
              </li>
              <li>
                <strong>Dados de uso:</strong> Podemos coletar informações sobre como você acessa e usa nossos serviços, incluindo seu endereço IP, tipo de navegador e informações do dispositivo.
              </li>
              <li>
                <strong>Cookies:</strong> utilizamos cookies e tecnologias de rastreamento semelhantes para melhorar sua experiência e coletar informações sobre como nossos serviços são usados.
              </li>
            </ul>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-3">2. Como usamos suas informações</h3>
            <p className="text-gray-600 mb-2">
              Podemos usar suas informações para os seguintes fins:
            </p>
            <ul className="list-disc ml-6 space-y-2 text-gray-600">
              <li>
                <strong>Para fornecer nossos serviços:</strong> Usamos suas informações pessoais para criar e gerenciar sua conta, fornecer suporte ao cliente e processar transações.
              </li>
              <li>
                <strong>Para melhorar nossos serviços:</strong> Analisamos dados de uso para entender como nossos serviços são usados e para melhorar nossas ofertas.
              </li>
              <li>
                <strong>Para nos comunicarmos com você:</strong> Podemos enviar atualizações, boletins informativos e materiais promocionais. Você pode cancelar essas comunicações a qualquer momento.
              </li>
            </ul>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-3">3. Compartilhamento e divulgação de dados</h3>
            <p className="text-gray-600 mb-2">
              Não vendemos ou alugamos suas informações pessoais a terceiros. Podemos compartilhar suas informações nas seguintes circunstâncias:
            </p>
            <ul className="list-disc ml-6 space-y-2 text-gray-600">
              <li>
                <strong>Com prestadores de serviços:</strong> podemos contratar prestadores de serviços terceirizados para auxiliar em nossas operações, como processamento de pagamentos e comunicações por e-mail. Estes fornecedores têm acesso às suas informações apenas para desempenhar as suas funções e são obrigados a protegê-las.
              </li>
              <li>
                <strong>Requisitos legais:</strong> Poderemos divulgar suas informações se exigido por lei ou em resposta a solicitações válidas de autoridades públicas.
              </li>
            </ul>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-3">4. Segurança de dados</h3>
            <p className="text-gray-600">
              Tomamos medidas razoáveis para proteger suas informações pessoais contra acesso, uso ou divulgação não autorizada. 
              No entanto, nenhum método de transmissão pela Internet ou armazenamento eletrônico é 100% seguro e não podemos garantir a sua segurança absoluta.
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-3">5. Seus direitos</h3>
            <p className="text-gray-600 mb-2">Você tem o direito de:</p>
            <ul className="list-disc ml-6 space-y-2 text-gray-600">
              <li>Acessar as informações pessoais que mantemos sobre você</li>
              <li>Solicitar correções em suas informações pessoais</li>
              <li>Solicitar a exclusão de suas informações pessoais, sujeito a certas exceções</li>
              <li>Desativar comunicações de marketing</li>
            </ul>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-3">6. Alterações nesta Política de Privacidade</h3>
            <p className="text-gray-600">
              Poderemos atualizar esta Política de Privacidade de tempos em tempos. Iremos notificá-lo sobre quaisquer alterações 
              publicando a nova política em nosso site. O uso continuado de nossos serviços após quaisquer alterações constitui 
              sua aceitação da política revisada.
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-3">7. Contate-nos</h3>
            <p className="text-gray-600">
              Se você tiver alguma dúvida sobre esta Política de Privacidade ou nossas práticas de dados, 
              entre em contato conosco pelo e-mail team.novacontent@gmail.com.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}